"use client";

import React from "react";

interface VideoBackgroundProps {
  videoSrc?: string; // the path/URL to the MP4
}

export default function VideoBackground({ videoSrc }: VideoBackgroundProps) {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          left: 0,
          top: 0,
          zIndex: 0,
        }}
      >
        <source src={videoSrc} type="video/mp4" />
        {/* Fallback text if the browser doesn't support the <video> tag */}
        Your browser does not support the video tag.
      </video>

      {/* Optional Overlay (darken, gradient, etc.) */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.6)", // 60% black overlay
        }}
      />
    </div>
  );
}
